import './style/index.js';

import _Chat from './chat';

export const Chat = _Chat;

export * from './type';
export default Chat;
